export enum EmailDomainState {
  VERIFIED = "VERIFIED",
  FAILED = "FAILED",
}
